import nse1 from '../assets/png/nse1.JPG';
import nse2 from '../assets/png/nse2.JPG';
import sql from '../assets/png/sql.JPG';
import python from '../assets/png/python.JPG';
import aws from '../assets/png/aws.JPG';

export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : 'AWS Cloud Practitioner',
            details : 'A cloud computing certification program by Amazon Web Services',
            date : 'April 06, 2023',
            field : 'Cloud',
            image : aws
        },
        {
            id : 2,
            title : 'Network Security Associate 2',
            details : 'A networking certification progtam by Fortinet',
            date : 'July 22, 2022',
            field : 'Networking',
            image : nse2
        },
        {
            id : 3,
            title : 'Network Security Associate 1',
            details : 'A networking certification progtam by Fortinet',
            date : 'September 6. 2021',
            field : 'Networking',
            image : nse1
        },
        {
            id : 4,
            title : 'SQL Certification',
            details : 'SQL (Basic) Certification by HackerRank',
            date : 'September 14, 2021',
            field : 'Database',
            image : sql
        },
        {
            id : 5,
            title : 'Python Certification',
            details : 'Python (Basic) Certification by HackerRank',
            date : 'October 21,2021',
            field : 'Coding',
            image : python
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/